import moment from "moment";
import React, { useMemo } from "react";

import style from "./index.module.scss";
import { getStrBySlice, useDeviceType } from "../../../../polyfills";
import { ChatMessageItem } from "../../../../types";
import MarkFilterContent from "./Components/MarkFilterContent";
import useMessageScroll from "../../../../Utils/useMessageScroll";

interface RecordListItem {
    item: ChatMessageItem;
    searchText: string;
    clearSearchText?: () => void;
    onClose: () => void;
}

export default function RecordList({
    item,
    searchText,
    clearSearchText,
    onClose
}: RecordListItem) {
    const { isPC } = useDeviceType();
    const scroller = useMessageScroll();

    const size = isPC ? 36 : 20;

    const data = useMemo(() => {
        const search = searchText.trim();
        if (search.length === 0) return;
        return getStrBySlice(item.content || "", search, size);
    }, [item.content, searchText]);

    // 双击进入改条记录详情页
    const onClick = () => {
        clearSearchText?.();
        onClose();
        scroller.scrollToMessage(item.guid);
    };

    return (
        <div className={style.root}>
            <div className={style.info}>
                <div>{`${item.sender.name} - ${item.sender.no}`}</div>
                <div className={style.time}>
                    {item.sendDate
                        ? moment(item.sendDate).format("YYYY-MM-DD HH:mm:ss")
                        : "--"}
                </div>
            </div>

            <div className={style.msgWrapper}>
                {isPC && (
                    <div onClick={onClick} className={style.msg}>
                        <MarkFilterContent data={data} content={item.content} />
                    </div>
                )}

                {!isPC && (
                    <div onClick={onClick} className={style.msg}>
                        <MarkFilterContent data={data} content={item.content} />
                    </div>
                )}
            </div>
        </div>
    );
}
